export enum EventStatusEnum {
    New = 1,
    Visible = 2,
    Active = 3
}
